import { Cloudinary } from "@cloudinary/url-gen";

export const cloudinaryInstance = new Cloudinary({
  cloud: {
    cloudName: process.env.REACT_APP_CLOUDINARY_API_KEY,
  },
});
